export default "__VITE_ASSET__Dq9FGEB$__"